import { FC } from 'react';
import { SelfServiceAPI } from 'types';
import StateMessaging from '../BookingDetails/StateMessaging';
import { FailedScheduledPaymentContainer } from '../Alerts/Inline/FailedScheduledPayment';
import { ScheduledPaymentCreditCardExpiredContainer } from '../Alerts/Inline/ScheduledPaymentCreditCardExpired';
import { InPathFlightBookingAlert } from 'components/InPathFlightBookingAlert';
import QantasPassNotification from './components/QantasPassNotification';
import { showPaidByQantasTravelPass } from './utils/showPaidByQantasTravelPass';

interface BookingDetailsProps {
  booking: SelfServiceAPI.Booking;
}

const BookingNotifications: FC<BookingDetailsProps> = ({ booking }) => {
  const showQantasPassNotification = showPaidByQantasTravelPass(booking);

  return (
    <>
      {showQantasPassNotification && <QantasPassNotification />}
      <StateMessaging booking={booking} />
      <InPathFlightBookingAlert />
      <FailedScheduledPaymentContainer />
      <ScheduledPaymentCreditCardExpiredContainer />
    </>
  );
};

export default BookingNotifications;
